export const Halloween = {
    letTheHauntingBegin : () => {
        let ghostTown = document.querySelector('.ghost-town');
        let ghostly = document.querySelector('.content.home');
        if (ghostTown && ghostly) {
            ghostTown.classList.toggle('hidden');
            ghostly.classList.add('ghostly');
            let ghost = document.querySelector(".ghost");
            startGhost();
            function startGhost() {
                setTimeout(() => {
                    ghost.classList.toggle("movingRight");
                    setTimeout(() => {
                        ghost.classList.toggle("movingRight");
                        ghost.classList.toggle("hoverRight");
                        setTimeout(() => {
                            ghost.classList.toggle("hoverRight");
                            ghost.classList.toggle("movingLeft");
                            setTimeout(() => {
                                ghost.classList.toggle("movingLeft");
                                startGhost();
                            }, 6000);
                        }, 5850);
                    }, 6000);
                }, 5850);
            }
        }
    }
};
